module.exports = __webpack_public_path__ + "static/media/useCaseHero3x.81ee0c00.png";